import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { PreInitSettingsService } from 'src/app/core/services/settings/pre-init-setting.service';
import { catchError, map } from 'rxjs/operators';
import { EMPTY } from 'rxjs';
import { ADPResourceService } from 'digital-core';

@Injectable({
  providedIn: 'root'
})
export class AddAMemberService {
  middleWareUrl: string;
  accountApiPath: string;
  salesforceInvitationEmailTemplateKey: string;

  constructor(
    private httpClient: HttpClient,
    private preInitSettingsService: PreInitSettingsService,
    public resourceService: ADPResourceService,
  ) {
    this.middleWareUrl = this.preInitSettingsService.getSettings().middleWare.middlewareUrl;
    this.accountApiPath = this.preInitSettingsService.getSettings().middleWare.accountPath;
    this.salesforceInvitationEmailTemplateKey = this.resourceService.getPortalSetting("Global_Salesforce_Invitation_Email_Template_Key").Value;
  }

  postInviteSubmit(data) {
    const oktaPrefix = this.preInitSettingsService.getSiteSettings().oktaPrefix.toUpperCase();
    const inviteUrl = window.location.origin + this.resourceService.getPortalSetting('URL_AcceptInvite').Value;
    return this.httpClient.post(`${this.middleWareUrl}${this.accountApiPath}invite?inviteUri=${encodeURIComponent(inviteUrl)}&salesforceInvitationEmailTemplateKey=${encodeURIComponent(this.salesforceInvitationEmailTemplateKey )}&oktaPrefix=${oktaPrefix}`, data).pipe(
      map((result) => {
        return result;
      },
      catchError(() => {
        return EMPTY;
      }))
    );
  }
}
